import {IApiModel} from './api-model.interface';


export class BankConnectedModel implements IApiModel<BankConnectedModel> {
    name: string;
    id: number;
    tenant: any;
    bic: string;
    accountCurrency: string;
    location: string;
    bankName: string;
    accounts: any;
    specialStatus: string;
    bankConnection: number;
    getApiModel(): any {
        return undefined;
    }

    setFromApiModel(apiModel: any): this {
        this.name = apiModel.name;
        this.bankName = apiModel.name;
        this.id = apiModel.id;
        this.bic = apiModel.bic;
        this.accounts = apiModel.accounts;
        this.accounts.forEach(account => {
            account.offline = account.status === 'OFFLINE';
            account.disconnected = account.status === 'DISCONNECTED';
            account.integrated = account.status === 'API';
            account.displayName = account.alias ? account.alias : account.name;
            
            if(account.offline) {
                this.specialStatus = 'Setup.Bank.Offline';
            }
            if(account.integrated) {
                this.specialStatus = 'Setup.Bank.Api';
            }
        });

        this.tenant = apiModel.tenant;
        this.bankConnection = apiModel.open_banking_connection;

        //CTLY-4171 w/a till currency support
        this.accountCurrency = apiModel.accountCurrency;
        return this;
    }
}
